import ListSchedules from "@/views/service_provider/services/container_op/ListSchedules.vue";
import ShowSchedule from "@/views/service_provider/services/container_op/ShowSchedule.vue";
import ShowAttachments from "@/views/service_provider/services/container_op/ShowAttachments.vue";
import NewSchedule from "@/views/service_provider/services/container_op/NewSchedule.vue";
import EditSchedule from "@/views/service_provider/services/container_op/EditSchedule.vue";
import EditContainer from "@/views/service_provider/services/container_op/EditContainer.vue";
import EditTechnicians from "@/views/service_provider/services/container_op/EditTechnicians.vue";
import EditService from "@/views/service_provider/services/container_op/EditService.vue";

import { routerUtilities } from "@/components/views/mixins/module_routes.js";
const [META, routeName] = routerUtilities({
  entity: "sp",
  role: "services",
  permission: "container_op",
});

export default [
  {
    path: "/service_provider/:service_provider_id/services/container_op/list_schedules",
    name: routeName("list_schedules"),
    component: ListSchedules,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/show_schedule/:container_scheduled_service_id",
    name: routeName("show_schedule"),
    component: ShowSchedule,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/show_attachments/:container_scheduled_service_id/:container_service_id",
    name: routeName("show_attachments"),
    component: ShowAttachments,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/new_schedule",
    name: routeName("new_schedule"),
    component: NewSchedule,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/edit_schedule/:container_scheduled_service_id",
    name: routeName("edit_schedule"),
    component: EditSchedule,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/edit_container/:container_scheduled_service_id",
    name: routeName("edit_container"),
    component: EditContainer,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/edit_technicians/:container_scheduled_service_id",
    name: routeName("edit_technicians"),
    component: EditTechnicians,
    props: true,
    meta: META
  },
  {
    path: "/service_provider/:service_provider_id/services/container_op/edit_service/:container_scheduled_service_id/:container_service_id",
    name: routeName("edit_service"),
    component: EditService,
    props: true,
    meta: META
  },
];
